import {breakpointsBootstrapV5, useBreakpoints} from '@vueuse/core';

export function useBsBreakpoints() {
  const bsBreakpoints = {
    ...breakpointsBootstrapV5,
    xxxl: 1900, // Requested by design team
    macBook: 3024, // Requested by Slobo
  };
  const breakpoints = useBreakpoints(bsBreakpoints);
  const activeBreakpoint = breakpoints.active();
  const isMacBook = breakpoints.greaterOrEqual('macBook');
  const isMobile = breakpoints.smallerOrEqual('sm');
  const isTablet = breakpoints.between('sm', 'lg');
  const isSmallScreen = breakpoints.smaller('lg');
  return {
    breakpoints,
    bsBreakpoints,
    breakpointsBootstrapV5,
    activeBreakpoint,
    isMacBook,
    isMobile,
    isTablet,
    isSmallScreen,
  };
}
